import { defineComponent as R, computed as S, watch as V, createElementBlock as r, openBlock as o, withDirectives as C, createBlock as c, createCommentVNode as p, normalizeClass as d, unref as i, createVNode as u, withModifiers as B, Teleport as E, createElementVNode as b, normalizeStyle as O, renderSlot as N, Fragment as f, renderList as v, withCtx as $ } from "vue";
import "./CommentTileCore.vue_vue_type_style_index_0_scoped_db29f5cd_lang-BGz-jqNx.js";
import { t as D } from "./tooltip-YeSRTnG0.js";
/* empty css                                                                      */
/* empty css                                                                        */
/* empty css                                                                      */
import "./idb-35dVPy4g.js";
import "./SvgRender.js";
import "./icon-C5cGsR9k.js";
import { _ as H } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
/* empty css                                                                  */
import "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import "./OverflowTooltip.js";
import { _ as y } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
/* empty css                                                                    */
import "./Chip.js";
/* empty css                                                                  */
import "./main-Bh5cSLmY.js";
/* empty css                                                          */
import "./debounce-BJrVv5jG.js";
/* empty css                                                                     */
/* empty css                                                                    */
import "./SearchInput.js";
import "./LoadMoreWrapper.js";
import "./Select-Dbr2pXH_.js";
/* empty css                                                                         */
/* empty css                                                                            */
import "./StatusSelect.js";
/* empty css                                                                      */
/* empty css                                                                */
import "./Reaction.vue_vue_type_style_index_0_scoped_a67a1bb4_lang-WDRHCN3u.js";
/* empty css                                                                     */
/* empty css                                                                           */
/* empty css                                                                        */
/* empty css                                                               */
/* empty css                                                                */
/* empty css                                                                          */
import { u as P } from "./usePositioning-DoUl_PGT.js";
/* empty css                                                                      */
/* empty css                                                                        */
/* empty css                                                                */
/* empty css                                                                        */
/* empty css                                                                     */
/* empty css                                                        */
/* empty css                                                                        */
/* empty css                                                                            */
/* empty css                                                                            */
/* empty css                                                                     */
/* empty css                                                                      */
/* empty css                                                                            */
import "./MainCalendar.js";
import "./CalendarNavigationControl.js";
/* empty css                                                                       */
import q from "./MenuActionItem.js";
/* empty css                                                                          */
/* empty css                                                                  */
/* empty css                                                                       */
/* empty css                                                                   */
/* empty css                                                  */
import "./js.cookie-CA0diDCW.js";
import "./fileManager-BNE_Afa-.js";
import "pinia";
/* empty css                                                                        */
import "./CommentUploadFile.ce.vue_vue_type_script_lang-Bi4IeKWp.js";
import { _ as F } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const L = {
  key: 0,
  class: "actions-top"
}, Q = {
  key: 0,
  class: "additional-setting"
}, j = {
  key: 0,
  class: "menu-items-groups"
}, G = /* @__PURE__ */ R({
  __name: "MoreActions",
  props: {
    actionsTop: { default: void 0 },
    additionalOptions: { default: void 0 },
    icon: { default: "EllipsisVertical" },
    size: { default: "medium" },
    menuItems: {},
    tooltip: { default: "More actions" }
  },
  emits: ["show", "hide"],
  setup(s, { emit: z }) {
    const k = D, n = s, { targetRef: M, computedStylePopover: x, popoverRef: w, opened: l, toggleMenu: A, hideMenu: h } = P(void 0), m = S(() => n.actionsTop?.filter((t) => t.visible !== !1) || []), T = (t) => {
      n.additionalOptions?.action && n.additionalOptions.action(t);
    }, I = (t, g) => {
      t.action && t?.action(g), t.preventClose || (t.subMenu?.length || 0) > 0 || t.confirm || h();
    }, _ = z;
    return V(l, (t) => {
      _(t ? "show" : "hide");
    }), (t, g) => (o(), r("div", {
      ref_key: "targetRef",
      ref: M,
      class: "tess-more-action"
    }, [
      C((o(), r("div", {
        class: d(["tess-more-action-trigger", { [n.size]: !0, active: i(l) }])
      }, [
        u(i(y), {
          type: "secondary",
          class: d({ active: i(l) }),
          label: "",
          "prefix-icon": n.icon,
          size: n.size,
          onClick: B(i(A), ["stop", "prevent"])
        }, null, 8, ["class", "prefix-icon", "size", "onClick"])
      ], 2)), [
        [i(k), { content: n.tooltip, delay: [300, 0], hideOnClick: !i(l) }]
      ]),
      i(l) ? (o(), c(E, {
        key: 0,
        to: "body"
      }, [
        b("div", {
          ref_key: "popoverRef",
          ref: w,
          class: "tess-more-action-menu",
          style: O({ ...i(x) })
        }, [
          m.value.length > 0 || s.additionalOptions ? (o(), r("div", L, [
            b("div", {
              class: "quick-actions",
              style: O({ "--number-item": m.value.length })
            }, [
              (o(!0), r(f, null, v(m.value, (e) => C((o(), c(i(y), {
                key: e.id,
                type: "secondary",
                class: d(["action-item", { danger: e.type == "danger" }]),
                onClick: (a) => I(e, a)
              }, {
                default: $(() => [
                  u(i(H), {
                    name: e.icon || ""
                  }, null, 8, ["name"])
                ]),
                _: 2
              }, 1032, ["class", "onClick"])), [
                [i(k), { content: e.tooltip, delay: [300, 0], hideOnClick: !e.preventClose }]
              ])), 128))
            ], 4),
            N(t.$slots, "additional-setting", {}, () => [
              s.additionalOptions ? (o(), r("div", Q, [
                u(i(y), {
                  type: "secondary",
                  label: s.additionalOptions?.label,
                  size: "small",
                  "prefix-icon": s.additionalOptions?.icon,
                  onClick: T
                }, null, 8, ["label", "prefix-icon"])
              ])) : p("", !0)
            ], !0)
          ])) : p("", !0),
          (o(!0), r(f, null, v(n.menuItems, (e) => (o(), r("div", {
            key: e.label,
            class: "menu-items"
          }, [
            e.visible !== !1 ? (o(), r("div", j, [
              (o(!0), r(f, null, v(e.items, (a) => (o(), c(q, {
                key: a.id,
                layer: 1,
                data: a,
                direction: void 0,
                onHide: i(h)
              }, null, 8, ["data", "onHide"]))), 128))
            ])) : p("", !0)
          ]))), 128))
        ], 4)
      ])) : p("", !0)
    ], 512));
  }
}), ri = /* @__PURE__ */ F(G, [["__scopeId", "data-v-6d743670"]]);
export {
  ri as default
};
